import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconZoomOutSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-zoom-out-sharp__a)">
      <g clipPath="url(#icon-zoom-out-sharp__b)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M9.909 17.578v1h2v-4.691l.059-.059-.059-.058v-1.301h-1.001l-.298.001-.057-.056-.056.056-3.693.004-1 .001.002 2h1l1.689-.003-4.318 4.319-.708.707 1.415 1.414.707-.707 4.318-4.318v1.691Z"
          clipRule="evenodd"
        />
      </g>
      <g clipPath="url(#icon-zoom-out-sharp__c)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M14.89 6.393v-1h-2v4.69l-.059.06.059.058v1.3h1.3l.055.056.057-.057 3.693-.004h1l-.002-2h-1l-1.69.002 4.32-4.318.706-.707-1.414-1.414-.707.707-4.318 4.318V6.393Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="icon-zoom-out-sharp__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="icon-zoom-out-sharp__b">
        <path fill="currentColor" d="m15.998 16.485-8.1 8.1-8.1-8.1 8.1-8.1z" />
      </clipPath>
      <clipPath id="icon-zoom-out-sharp__c">
        <path fill="currentColor" d="m8.8 7.485 8.1-8.1 8.1 8.1-8.1 8.1z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconZoomOutSharp);
export default Memo;
